export const getLoading = state =>
  state.alert && state.alert.type === 'alert-reloading';
